module.exports = __webpack_public_path__ + "img/LogotipoVSF.5a8d2faa.png";